module.exports = __webpack_public_path__ + "static/media/medycyna.ec467c14.svg";